'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthType$$anon$154(typ$2, outer) {
  this.cdd = null;
  this.cdd = typ$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$TwoFactorAuthType$$anon$154 as $c_Lpresto_types$TwoFactorAuthType$$anon$154 };
$p = $c_Lpresto_types$TwoFactorAuthType$$anon$154.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthType$$anon$154;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthType$$anon$154() {
}
export { $h_Lpresto_types$TwoFactorAuthType$$anon$154 as $h_Lpresto_types$TwoFactorAuthType$$anon$154 };
$h_Lpresto_types$TwoFactorAuthType$$anon$154.prototype = $p;
$p.nB = (function(seq) {
  return seq.b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it) => {
    var x = it.e2.qn;
    var x$2 = this.cdd;
    return (x === x$2);
  })));
});
var $d_Lpresto_types$TwoFactorAuthType$$anon$154 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthType$$anon$154, "presto.types$TwoFactorAuthType$$anon$154", ({
  a2v: 1,
  bM: 1
}));
export { $d_Lpresto_types$TwoFactorAuthType$$anon$154 as $d_Lpresto_types$TwoFactorAuthType$$anon$154 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Type$$anon$154.js.map
